const React = require("react");
const T = React.PropTypes;

require("./ReportPane.less");

const DistrictReportType = require("~/types/DistrictReport.js");
const ReactCSSTransitionGroup = require("react-addons-css-transition-group");

const navigator = require("~/navigator.js"); 

const ReportPane = React.createClass({
    propTypes: { 
        onClose: T.func.isRequired,
        District: T.string.isRequired,
        DistrictReport: DistrictReportType.isRequired,
        AuditType: T.string.isRequired
    },
    renderStoresGood() { 
        if (this.props.DistrictReport !== null &&
            this.props.DistrictReport !== undefined)
        {
            var k = 0; 
            const elements = this.props.DistrictReport.Stores.map((s) => {
                if (s.HasAudit) {
                    let PKID = s.AuditPKID;
                    let Number = s.Number;
                    let Type = this.props.AuditType;
                    let Legacy = s.IsLegacy; 

                    if (Type === "customerReadiness") Type = "customerReadinessAudits";
                    else if (Type === "FacilityAudit") Type = "FacilityAudits";
                    else if (Type === "ApartmentAudit") Type = "ApartmentAudits"; 

                    let link = "";

                    if (!Legacy) link = "#" + navigator.GetLink.ToSummary(Type, Number, PKID);
                    else link = "#" + navigator.GetLink.ToLegacySurvey(Type, Number, PKID); 

                    return (<li key={++k} className="ReportPane-Li"><a href={link} target="_blank"><b>{s.Name}</b></a></li>)
                }
            }); 

            return elements; 
        }
    },
    renderStoresBad() { 
        if (this.props.DistrictReport !== null &&
           this.props.DistrictReport !== undefined)
        {
            var k = 0; 
            const elements = this.props.DistrictReport.Stores.map((s) => {
                if (!s.HasAudit)
                    return (<li key={++k} className="ReportPane-Li"><b>{s.Name}</b></li>)
            }); 

            return elements; 
        }
    }, 
    render() {

        let goodstores = this.renderStoresGood();
        let badstores = this.renderStoresBad(); 

        return (<ReactCSSTransitionGroup transitionName="ReportPane"
                                         transitionEnterTimeout={700}
                                         transitionLeaveTimeout={700}
                                         transitionAppear={true}
                                         transitionAppearTimeout={700}>
        <div>
    <div className="cs-ReportPane"></div>
    <div className="cs-ReportPane__layer2">
        <div className="cs-ReportPane__layer3">
            <div className="cs-ReportPane__layer4">
        <h3 className="cs-ReportPane__header">District: {this.props.District}</h3>
        <button onClick={() => {this.props.onClose()}} className="btn btn-danger cs-ReportPane__exit__btn">X</button>
            </div>
        </div>
        <div className="ReportPane-List">
            <div>
                <h3><b>Complete</b></h3>
                <hr />
        <ul className="ReportPane-GoodList">
            {goodstores}
        </ul>
            </div>
            <div>
                <h3><b>Incomplete</b></h3>
                <hr />
            <ul className="ReportPane-GoodList">
                {badstores}
            </ul>
            </div>
        </div>
    </div>
    </div>
    </ReactCSSTransitionGroup>);
    }
});

module.exports = ReportPane; 


// WEBPACK FOOTER //
// ./src/components/Reports/ReportPane/ReportPane.jsx